/**
 * Created by bhavinhariyani on 09/03/17.
 */

define(function (require, exports, module) {

    'use strict';

    exports.setFocus = function(){
        return {
            link: function (scope, element, attrs) {
                setTimeout(function(){
                    element.focus();
                }, 0);
            }
        };
    };
});





//////////////////
// WEBPACK FOOTER
// ./scripts/modules/portal/focus.js
// module id = 11
// module chunks = 0